<div class="my-5" [ngSwitch]="value">
  <!-- case 1 -->
  <div class="container-fluid v4-bg-img" *ngSwitchCase="1">
    <div
      class="d-flex justify-content-center align-items-center wrapper loader-mtop-bottom"
    >
      <!-- <svg class="hourglass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 206" preserveAspectRatio="none">
          <path class="middle" d="M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z"/>
          <path class="outer" d="M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z"/>
      </svg> -->
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
      <div class="loading-txt">
        &nbsp;&nbsp;{{ "download" | translator }}...
      </div>
    </div>
    <!-- <div class="row mx-5">
      <div class="col-md-8 col-12 p-0">
        <div class="card">
          <p-table [value]="tableList" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th>.....</th>
                <th>.....</th>
                <th>.....</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
              <tr>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="col-md-4 col-12 p-0">
        <div class="container">
          <p-skeleton width="100%" height="440px"></p-skeleton>
        </div>
      </div>
    </div> -->
  </div>
  <!-- case 1 END -->

  <!-- case 2 -->
  <div class="container-fluid v4-bg-img" *ngSwitchCase="2">
    <div
      class="d-flex justify-content-center align-items-center wrapper loader-mtop-bottom"
    >
      <!-- <svg class="hourglass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 206" preserveAspectRatio="none">
        <path class="middle" d="M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z"/>
        <path class="outer" d="M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z"/>
    </svg> -->
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
      <div class="loading-txt">
        &nbsp;&nbsp;{{ "download" | translator }}...
      </div>
    </div>
    <!-- <div class="row mx-5">
      <div class="col-md-12 col-12 p-0">
        <div class="card">
          <p-table [value]="tableList" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th>.....</th>
                <th>.....</th>
                <th>.....</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
              <tr>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div> -->
  </div>
  <!-- case 2 END -->

  <!-- case 3 -->
  <div class="container-fluid v4-bg-img" *ngSwitchCase="3">
    <div
      class="d-flex justify-content-center align-items-center wrapper loader-mtop-bottom"
    >
      <!-- <svg class="hourglass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 206" preserveAspectRatio="none">
          <path class="middle" d="M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z"/>
          <path class="outer" d="M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z"/>
      </svg> -->
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
      <div class="loading-txt">
        &nbsp;&nbsp;{{ "download" | translator }}...
      </div>
    </div>
    <!-- <div class="row mx-5">
      <div class="col-md-12 col-12 p-0">
        <div class="card">
          <p-table [value]="tableList" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th>.....</th>
                <th>.....</th>
                <th>.....</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
              <tr>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <br> <br>
      <hr> <br> <br>
      <div class="col-md-12 col-12 p-0">
        <div class="container">
          <p-skeleton width="100%" height="440px"></p-skeleton>
        </div>
      </div>
      <br> <br>
    </div> -->
  </div>
  <!-- case 3 END -->

  <!-- case 4 -->
  <div *ngSwitchCase="4">
    <div class="container my-5">
      <div class="row">
        <div class="col-12 my-3">
          <p-skeleton width="100%" height="100px"></p-skeleton>
        </div>
        <div class="col-4">
          <p-skeleton width="100%" height="700px"></p-skeleton>
        </div>
        <div class="col-8">
          <div class="row">
            <div class="col-4 my-1">
              <p-skeleton width="100%" height="350px"></p-skeleton>
            </div>
            <div class="col-4 my-1">
              <p-skeleton width="100%" height="350px"></p-skeleton>
            </div>
            <div class="col-4 my-1">
              <p-skeleton width="100%" height="350px"></p-skeleton>
            </div>
            <div class="col-4">
              <p-skeleton width="100%" height="350px"></p-skeleton>
            </div>
            <div class="col-4">
              <p-skeleton width="100%" height="350px"></p-skeleton>
            </div>
            <div class="col-4">
              <p-skeleton width="100%" height="350px"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- case 4 END -->

  <!-- case 5 for data managment page  -->
  <div class="container-fluid desktop-skeleton" *ngSwitchCase="5">
    <div class="row mx-5">
      <div class="col-md-12 col-12 p-0">
        <div class="d-flex justify-content-between">
          <p-skeleton width="10rem" height="2rem"></p-skeleton>
          <p-skeleton
            width="30rem"
            height="2rem"
            styleClass="mx-2"
          ></p-skeleton>
          <div class="d-flex">
            <p-skeleton width="5rem" height="2rem"></p-skeleton>
            <p-skeleton
              width="5em"
              height="2rem"
              styleClass="mx-2"
            ></p-skeleton>
            <p-skeleton width="5rem" height="2rem"></p-skeleton>
          </div>
        </div>
        <p-skeleton height="4rem" styleClass="my-3"></p-skeleton>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between">
            <p-skeleton
              width="1rem"
              height="1rem"
              styleClass="mx-1"
            ></p-skeleton>
            <p-skeleton
              width="8rem"
              height="1rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <div class="mx-1 box-none">
            <p-skeleton
              width="14rem"
              height="14rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center my-2">
          <div class="d-flex justify-content-between">
            <p-skeleton
              width="1rem"
              height="1rem"
              styleClass="mx-1"
            ></p-skeleton>
            <p-skeleton
              width="8rem"
              height="1rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <div class="mx-1 box-none">
            <p-skeleton
              width="14rem"
              height="14rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <p-skeleton
            width="30rem"
            height="1.5rem"
            styleClass="mt-4"
          ></p-skeleton>
        </div>
      </div>
    </div>
  </div>
  <!-- case 5 for data managment page  END-->

  <!-- case 5 for data managment page this is for MOBILE-VIEW -->
  <div class="container mobile-skeleton" *ngSwitchCase="5">
    <div class="row mx-5">
      <div class="col-md-12 col-12 p-0">
        <p-skeleton height="2rem" styleClass="my-2"></p-skeleton>
        <p-skeleton height="2rem" styleClass="my-2"></p-skeleton>
        <div class="d-flex justify-content-between my-1">
          <p-skeleton width="5rem" height="2rem"></p-skeleton>
          <p-skeleton width="5rem" height="2rem" styleClass="mx-2"></p-skeleton>
          <p-skeleton width="5rem" height="2rem"></p-skeleton>
        </div>
        <div class="d-flex justify-content-center">
          <p-skeleton
            width="10rem"
            height="10rem"
            styleClass="my-3"
          ></p-skeleton>
        </div>
        <div class="d-flex justify-content-center">
          <p-skeleton width="15rem" height="1.5rem"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
  <!-- case 5 for data managment page this is for MOBILE-VIEW END-->

  <!-- case 6 for home page -->
  <div class="container desktop-skeleton" *ngSwitchCase="6">
    <div class="row mx-5">
      <div class="col-md-12 col-12 p-0">
        <div class="d-flex justify-content-between"></div>
        <div class="shaddow">
          <p-skeleton height="4rem" styleClass="my-3"></p-skeleton>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <div class="shaddow">
            <p-skeleton
              width="10rem"
              height="10rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <div class="shaddow">
            <p-skeleton
              width="10rem"
              height="10rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <div class="shaddow">
            <p-skeleton
              width="10rem"
              height="10rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <div class="shaddow">
            <p-skeleton
              width="10rem"
              height="10rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <div class="shaddow">
            <p-skeleton
              width="10rem"
              height="10rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <div class="mx-1 box-none-case-6">
            <div class="shaddow">
              <p-skeleton
                width="10rem"
                height="10rem"
                styleClass="mx-1"
              ></p-skeleton>
            </div>
          </div>
          <div class="mx-1 box-none-case-6">
            <div class="shaddow">
              <p-skeleton
                width="10rem"
                height="10rem"
                styleClass="mx-1"
              ></p-skeleton>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center align-items-center my-3">
          <div class="shaddow">
            <p-skeleton
              width="10rem"
              height="10rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <div class="shaddow">
            <p-skeleton
              width="10rem"
              height="10rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <div class="shaddow">
            <p-skeleton
              width="10rem"
              height="10rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <div class="shaddow">
            <p-skeleton
              width="10rem"
              height="10rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <div class="shaddow">
            <p-skeleton
              width="10rem"
              height="10rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <div class="mx-1 box-none-case-6">
            <div class="shaddow">
              <p-skeleton
                width="10rem"
                height="10rem"
                styleClass="mx-1"
              ></p-skeleton>
            </div>
          </div>
          <div class="mx-1 box-none-case-6">
            <div class="shaddow">
              <p-skeleton
                width="10rem"
                height="10rem"
                styleClass="mx-1"
              ></p-skeleton>
            </div>
          </div>
        </div>
        <div class="shaddow">
          <p-skeleton height="3rem" styleClass="my-3"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
  <!-- case 6 for home page  END-->

  <!-- case 6 mobile skeleton -->
  <div class="container mobile-skeleton" *ngSwitchCase="6">
    <div class="row mx-5">
      <div class="col-md-12 col-12 p-0">
        <div class="d-flex justify-content-between"></div>
        <div class="shaddow">
          <p-skeleton height="4rem" styleClass="my-3"></p-skeleton>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <div class="shaddow">
            <p-skeleton
              width="15rem"
              height="18rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center my-3">
          <div class="shaddow">
            <p-skeleton
              width="15rem"
              height="18rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
        </div>
        <div class="shaddow">
          <p-skeleton height="3rem" styleClass="my-3"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
  <!-- case 6 mobile skeleton END -->

  <!-- case 7 skeleton -->
  <div class="container desktop-skeleton" *ngSwitchCase="7">
    <div class="row">
      <div class="col-4 px-5">
        <div class="d-flex justify-content-between my-3">
          <div class="shaddow">
            <p-skeleton width="7rem" height="1.5rem"></p-skeleton>
          </div>
          <div class="d-flex">
            <div class="shaddow-circle mx-1">
              <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
            </div>
            <div class="shaddow-circle mx-1">
              <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
            </div>
            <div class="shaddow-circle mx-1">
              <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
            </div>
            <div class="shaddow-circle mx-1">
              <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="shaddow">
          <p-skeleton height="2rem" styleClass="my-2"></p-skeleton>
        </div>
        <!-- card look ui -->
        <div class="row my-3">
          <div class="col-2">
            <div class="shaddow-rectangle">
              <p-skeleton
                borderRadius="16px"
                shape="rectangle"
                size="2.8rem"
              ></p-skeleton>
            </div>
          </div>
          <div class="col-10">
            <div class="shaddow-profile">
              <p-skeleton
                borderRadius="16px"
                width="100%"
                styleClass="mb-2"
              ></p-skeleton>
            </div>
            <div class="shaddow-profile">
              <p-skeleton borderRadius="16px" width="100%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-2">
            <div class="shaddow-rectangle">
              <p-skeleton
                borderRadius="16px"
                shape="rectangle"
                size="2.8rem"
              ></p-skeleton>
            </div>
          </div>
          <div class="col-10">
            <div class="shaddow-profile">
              <p-skeleton
                borderRadius="16px"
                width="100%"
                styleClass="mb-2"
              ></p-skeleton>
            </div>
            <div class="shaddow-profile">
              <p-skeleton borderRadius="16px" width="100%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-2">
            <div class="shaddow-rectangle">
              <p-skeleton
                borderRadius="16px"
                shape="rectangle"
                size="2.8rem"
              ></p-skeleton>
            </div>
          </div>
          <div class="col-10">
            <div class="shaddow-profile">
              <p-skeleton
                borderRadius="16px"
                width="100%"
                styleClass="mb-2"
              ></p-skeleton>
            </div>
            <div class="shaddow-profile">
              <p-skeleton borderRadius="16px" width="100%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-2">
            <div class="shaddow-rectangle">
              <p-skeleton
                borderRadius="16px"
                shape="rectangle"
                size="2.8rem"
              ></p-skeleton>
            </div>
          </div>
          <div class="col-10">
            <div class="shaddow-profile">
              <p-skeleton
                borderRadius="16px"
                width="100%"
                styleClass="mb-2"
              ></p-skeleton>
            </div>
            <div class="shaddow-profile">
              <p-skeleton borderRadius="16px" width="100%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-2">
            <div class="shaddow-rectangle">
              <p-skeleton
                borderRadius="16px"
                shape="rectangle"
                size="2.8rem"
              ></p-skeleton>
            </div>
          </div>
          <div class="col-10">
            <div class="shaddow-profile">
              <p-skeleton
                borderRadius="16px"
                width="100%"
                styleClass="mb-2"
              ></p-skeleton>
            </div>
            <div class="shaddow-profile">
              <p-skeleton borderRadius="16px" width="100%"></p-skeleton>
            </div>
          </div>
        </div>
        <!-- card look ui END -->
      </div>

      <div class="col-8">
        <div class="width-70 shaddow">
          <p-skeleton height="3rem"></p-skeleton>
        </div>
        <div class="d-flex justify-content-between mt-5">
          <div class="width-25 shaddow">
            <p-skeleton height="2rem"></p-skeleton>
          </div>
          <div class="width-45 shaddow">
            <p-skeleton height="2rem"></p-skeleton>
          </div>
          <div class="width-10 shaddow">
            <p-skeleton height="2rem"></p-skeleton>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
          <div class="width-25 shaddow">
            <p-skeleton height="2rem"></p-skeleton>
          </div>
          <div class="width-10 shaddow">
            <p-skeleton height="2rem"></p-skeleton>
          </div>
          <div class="width-45 shaddow">
            <p-skeleton height="2rem"></p-skeleton>
          </div>
        </div>
        <div class="width-70 shaddow mt-4">
          <p-skeleton height="1.5rem"></p-skeleton>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="d-flex justify-content-between mt-4">
              <div class="width-25 shaddow w-100">
                <p-skeleton height="2rem"></p-skeleton>
              </div>
              <div class="width-25 shaddow mx-1 w-100">
                <p-skeleton height="2rem"></p-skeleton>
              </div>
              <div class="width-25 shaddow w-100">
                <p-skeleton height="2rem"></p-skeleton>
              </div>
            </div>
          </div>
          <div class="col-4"></div>
          <div class="col-4">
            <div class="d-flex justify-content-between mt-4">
              <div class="width-25 shaddow w-100">
                <p-skeleton height="2rem"></p-skeleton>
              </div>
              <div class="width-25 shaddow mx-1 w-100">
                <p-skeleton height="2rem"></p-skeleton>
              </div>
              <div class="width-25 shaddow w-100">
                <p-skeleton height="2rem"></p-skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- case 7 skeleton END -->

  <!-- care 8 -->
  <div class="container" *ngSwitchCase="8">
    <div class="row mx-5 mob-mx-skeleton">
      <div class="col-md-12 col-12 p-0">
        <div class="mx-4">
          <p-skeleton
            width="7rem"
            height="1.5rem"
            styleClass="mb-2"
          ></p-skeleton>
          <p-skeleton
            width="3rem"
            height="1.5rem"
            styleClass="mb-2"
          ></p-skeleton>
          <p-skeleton width="15rem" height="3rem"></p-skeleton>
        </div>

        <div class="border-round border-1 surface-border p-4 surface-card">
          <div class="flex mb-3">
            <div>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
            </div>
          </div>
          <p-skeleton width="100%" height="70px"></p-skeleton>
          <div class="d-flex justify-content-between mt-3">
            <span>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
            </span>
            <span class="d-flex">
              <p-skeleton width="3rem" height="3rem"></p-skeleton>
              <span class="mx-2">
                <p-skeleton width="3rem" height="3rem"></p-skeleton>
              </span>
            </span>
          </div>
        </div>
        <div class="border-round border-1 surface-border p-4 surface-card">
          <div class="flex mb-3">
            <div>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
            </div>
          </div>
          <p-skeleton width="100%" height="70px"></p-skeleton>
          <div class="d-flex justify-content-between mt-3">
            <span>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
            </span>
            <span class="d-flex">
              <p-skeleton width="3rem" height="3rem"></p-skeleton>
              <span class="mx-2">
                <p-skeleton width="3rem" height="3rem"></p-skeleton>
              </span>
            </span>
          </div>
        </div>
        <div class="border-round border-1 surface-border p-4 surface-card">
          <div class="flex mb-3">
            <div>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
            </div>
          </div>
          <p-skeleton width="100%" height="70px"></p-skeleton>
          <div class="d-flex justify-content-between mt-3">
            <span>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
            </span>
            <span class="d-flex">
              <p-skeleton width="3rem" height="3rem"></p-skeleton>
              <span class="mx-2">
                <p-skeleton width="3rem" height="3rem"></p-skeleton>
              </span>
            </span>
          </div>
        </div>
        <div class="border-round border-1 surface-border p-4 surface-card">
          <div class="flex mb-3">
            <div>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
            </div>
          </div>
          <p-skeleton width="100%" height="70px"></p-skeleton>
          <div class="d-flex justify-content-between mt-3">
            <span>
              <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
            </span>
            <span class="d-flex">
              <p-skeleton width="3rem" height="3rem"></p-skeleton>
              <span class="mx-2">
                <p-skeleton width="3rem" height="3rem"></p-skeleton>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- case 8 end -->

  <!-- case 9  -->
  <div *ngSwitchCase="9">
    <div class="row mx-5">
      <div class="col-md-12 col-12 p-0 my-5">
        <div class="container-fluid">
          <p-skeleton width="100%" height="100px"></p-skeleton>
        </div>
      </div>
      <div class="col-md-12 col-12 p-0">
        <div class="card">
          <p-table [value]="tableList" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th>.....</th>
                <th>.....</th>
                <th>.....</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
              <tr>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
                <td><p-skeleton></p-skeleton></td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
  <!-- case 9 END -->

  <!-- case 5 for data managment page  -->
  <div class="container-fluid desktop-skeleton" *ngSwitchCase="10">
    <div class="row mx-5">
      <div class="col-md-12 col-12 p-0">
        <p-skeleton height="4rem" styleClass="my-3"></p-skeleton>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between">
            <p-skeleton
              width="1rem"
              height="1rem"
              styleClass="mx-1"
            ></p-skeleton>
            <p-skeleton
              width="8rem"
              height="1rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <div class="mx-1 box-none">
            <p-skeleton
              width="14rem"
              height="14rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center my-2">
          <div class="d-flex justify-content-between">
            <p-skeleton
              width="1rem"
              height="1rem"
              styleClass="mx-1"
            ></p-skeleton>
            <p-skeleton
              width="8rem"
              height="1rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <p-skeleton
            width="14rem"
            height="14rem"
            styleClass="mx-1"
          ></p-skeleton>
          <div class="mx-1 box-none">
            <p-skeleton
              width="14rem"
              height="14rem"
              styleClass="mx-1"
            ></p-skeleton>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <p-skeleton
            width="30rem"
            height="1.5rem"
            styleClass="mt-4"
          ></p-skeleton>
        </div>
      </div>
    </div>
  </div>
  <!-- case 5 for data managment page  END-->

  <!-- case 5 for data managment page this is for MOBILE-VIEW -->
  <div class="container mobile-skeleton" *ngSwitchCase="10">
    <div class="row mx-5">
      <div class="col-md-12 col-12 p-0">
        <p-skeleton height="2rem" styleClass="my-2"></p-skeleton>
        <p-skeleton height="2rem" styleClass="my-2"></p-skeleton>
        <div class="d-flex justify-content-between my-1">
          <p-skeleton width="5rem" height="2rem"></p-skeleton>
          <p-skeleton width="5rem" height="2rem" styleClass="mx-2"></p-skeleton>
          <p-skeleton width="5rem" height="2rem"></p-skeleton>
        </div>
        <div class="d-flex justify-content-center">
          <p-skeleton
            width="10rem"
            height="10rem"
            styleClass="my-3"
          ></p-skeleton>
        </div>
        <div class="d-flex justify-content-center">
          <p-skeleton width="15rem" height="1.5rem"></p-skeleton>
        </div>
      </div>
    </div>
  </div>
  <!-- case 5 for data managment page this is for MOBILE-VIEW END-->

  <div *ngSwitchDefault></div>
</div>
